<template>
  <div class="container">
    <div class="row">
      <div class="col">
        <div>
          <ul class="nav nav-pills mb-4" role="tablist" id="v-pills-tab">
            <li
              v-if="accountId == -1 && permissionsAccountId == -1"
              class="nav-item mr-2"
            >
              <button
                class="btn btn-outline-primary nav-link"
                v-bind:class="{ active: page == 1 }"
                v-on:click="changePage(1)"
              >
                All Groups
              </button>
            </li>
            <li
              v-if="accountId == -1 && permissionsAccountId == -1"
              class="nav-item"
            >
              <button
                class="btn btn-outline-primary nav-link mr-2"
                v-bind:class="{ active: page == 2 }"
                v-on:click="changePage(2)"
              >
                Users
              </button>
            </li>
            <li class="nav-item mr-2">
              <button
                v-if="accountId != -1 && permissionsAccountId == -1"
                class="btn btn-link nav-link"
                v-on:click="changePage(1)"
              >
                Back to All Accounts
              </button>
            </li>
            <li class="nav-item">
              <button
                v-if="permissionsAccountId != -1"
                class="btn btn-link nav-link"
                v-on:click="toAccount"
              >
                Back to Account
              </button>
            </li>
          </ul>
          <AccountGroupList v-if="page == 1" @selectedAccount="selectAccount" />
          <UserList v-if="page == 2" @selectedAccount="selectAccount" />
          <Account
            v-if="accountId != -1"
            v-bind:AccountId="accountId"
            @managePermissions="manageAccountPermissions"
          />
          <UserPermissions
            v-if="permissionsAccountId != -1"
            v-bind:AccountId="permissionsAccountId"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AccountGroupList from "@/components/ManageAccounts/AccountGroupList.vue";
import Account from "@/components/ManageAccounts/Account.vue";
import UserList from "@/components/ManageAccounts/UserList.vue";
import UserPermissions from "@/components/ManageAccounts/UserPermissions.vue";
//import $ from "jquery";

export default {
  name: "AccountManagement",
  components: {
    AccountGroupList,
    Account,
    UserList,
    UserPermissions
  },
  data() {
    return {
      page: 1,
      accountId: -1,
      permissionsAccountId: -1
    };
  },
  async mounted() {
    var view = this;
    if (view.$route.params.id) {
      view.page = -1;
      view.accountId = view.$route.params.id;
    }
  },
  methods: {
    changePage(num) {
      this.accountId = -1;
      this.permissionsAccountId = -1;
      this.page = num;
    },
    toAccount() {
      if (this.accountId == -1 && this.permissionsAccountId != -1) {
        this.accountId = this.permissionsAccountId;
        this.permissionsAccountId = -1;
      }
    },
    selectAccount(accountId) {
      this.page = -1;
      this.accountId = accountId.toString();
    },
    manageAccountPermissions(accountId) {
      this.page = -1;
      this.accountId = -1;
      this.permissionsAccountId = accountId;
    }
  }
};
</script>
